import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { NudgeContainerComponent } from "src/app/shared/components/nudge-container/nudge-container.component";
import { ThemeService } from "./theme/theme.service";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Subscription, filter } from "rxjs";
import { NudgeConfig, NudgeResponse } from "src/app/shared/models/nudge.model";
import { status_name } from "src/app/shared/global/constants";
import { NudgeEngineService } from "src/app/shared/services/nudge/nudge-engine.service";
import { NotificationService } from "src/app/shared/services/notification/notification.service";
import { TaskEmitService } from "src/app/shared/services/task-service/task-emit.service";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  private static readonly NUDGE_DISPLAY_MS = 10000;
  private static readonly NUDGE_ACTIVITY_WINDOW_MS = 2 * 60 * 1000;
  private static readonly TASK_DIALOG_REQUEST_QUERY_PARAM = "open_add_task_request";
  private static readonly TASK_STATUS_QUERY_PARAM = "default_status";
  private static readonly TASK_TYPE_QUERY_PARAM = "type";
  private static readonly TASK_DIALOG_NUDGE_IDS = new Set([
    "start-task",
    "start-reminder",
    "start-recurring-task",
    "start-priority",
    "start-subtask",
    "start-checklist",
  ]);
  currentURL: any;
  @ViewChild("reload") reload: any;
  @ViewChild(NudgeContainerComponent) nudgeContainer?: NudgeContainerComponent;
  homeNudges: NudgeConfig[] = [];
  private routerSubscription: Subscription;
  private nudgeSubscription: Subscription;
  showNudgeOverlay = false;
  private nudgeOverlayTimer?: ReturnType<typeof setTimeout>;
  private nextNudgeTimer?: ReturnType<typeof setTimeout>;
  private lastUserActivityAt = Date.now();

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private nudgeEngineService: NudgeEngineService,
    private notificationService: NotificationService,
    private taskEmitService: TaskEmitService
  ) {
    this.checkScreenWidth();
  }
  @HostListener("window:resize", [])
  onResize() {
    this.checkScreenWidth();
  }

  @HostListener("window:mousemove")
  @HostListener("window:click")
  @HostListener("window:keydown")
  @HostListener("window:scroll")
  onUserActivity() {
    this.lastUserActivityAt = Date.now();
  }

  private checkScreenWidth() {
    this.isToggled = window.innerWidth < 1024;
  }
  @Output("regenerateGraph") regenerateGraph = new EventEmitter();
  // toggle() {
  //   const active = this.themeService.getActiveTheme();
  //   if (active.name == "light") {
  //     this.themeService.setTheme("dark");
  //   } else {
  //     this.themeService.setTheme("light");
  //   }
  // }
  isToggled = false;
  buildVersion: any = environment.buildVersion;

  async ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(async () => {
        this.currentURL = this.router.url;
        this.onUserActivity();
        await this.loadAndShowNudge();
    });
    this.currentURL = this.router.url;
    this.nudgeSubscription = this.nudgeEngineService.activeNudges$.subscribe(() => {
      const scopedNudges = this.nudgeEngineService.getScopedNudges("home");
      this.homeNudges = this.showNudgeOverlay ? scopedNudges : [];
    });
    await this.loadAndShowNudge();
    // const active = this.themeService.getActiveTheme();
    // this.themeService.setTheme(active.name);
  }

  onNudgeCloseClick(nudge: NudgeConfig) {
    this.nudgeEngineService.dismissNudge(nudge.id);
    const remainingNudges = this.homeNudges.filter((item) => item.id !== nudge.id);
    this.homeNudges = remainingNudges;
    this.showNudgeOverlay = remainingNudges.length > 0;
  }

  onNudgeCtaClick(nudge: NudgeConfig) {
    if (nudge.id === "start-timesheet-approval") {
      this.notificationService.setTimesheetTab(1);
      this.router.navigate(["/time-sheet"]);
      return;
    }

    if (HomeComponent.TASK_DIALOG_NUDGE_IDS.has(nudge.id)) {
      this.router.navigate(["/task/list"], {
        queryParams: {
          [HomeComponent.TASK_DIALOG_REQUEST_QUERY_PARAM]: `${Date.now()}`,
          source: "nudge",
        },
      });
      return;
    }

    if (nudge.id === "start-task-approval") {
      this.router.navigate(["/task/list"], {
        queryParams: {
          [HomeComponent.TASK_STATUS_QUERY_PARAM]:
            status_name.UNDER_REVIEW_RECEIVE,
          [HomeComponent.TASK_TYPE_QUERY_PARAM]: "total",
          source: "nudge",
        },
      });
      return;
    }

    if (nudge.id === "start-overdue-task") {
      this.router.navigate(["/task/list"]).then(() => {
        setTimeout(() => {
          this.taskEmitService.setStatusData([], "overdue", []);
        }, 300);
      });
      return;
    }

    if (nudge.ctaRoute) {
      this.router.navigate([nudge.ctaRoute]);
    }
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.nudgeSubscription?.unsubscribe();
    if (this.nudgeOverlayTimer) {
      clearTimeout(this.nudgeOverlayTimer);
    }
    if (this.nextNudgeTimer) {
      clearTimeout(this.nextNudgeTimer);
    }
  }

  regenerateTableData(event: any) {
    this.regenerateGraph.emit(event);
    this.isToggled = event;
  }

  private async loadAndShowNudge() {
    const response = await this.nudgeEngineService.loadNextNudge("home");
    const scopedNudges = this.nudgeEngineService.getScopedNudges("home");

    if (scopedNudges.length) {
      this.showNudgeOverlay = true;
      this.homeNudges = scopedNudges;
      this.startNudgeOverlayTimer();
    } else {
      this.showNudgeOverlay = false;
      this.homeNudges = [];
    }

    this.scheduleNextNudgeCheck(response);
  }

  private startNudgeOverlayTimer() {
    if (this.nudgeOverlayTimer) {
      clearTimeout(this.nudgeOverlayTimer);
    }

    this.nudgeOverlayTimer = setTimeout(() => {
      if (!this.homeNudges.length) {
        this.showNudgeOverlay = false;
        return;
      }
      this.nudgeContainer?.closeAll();
    }, HomeComponent.NUDGE_DISPLAY_MS);
  }

  private scheduleNextNudgeCheck(response: NudgeResponse) {
    if (this.nextNudgeTimer) {
      clearTimeout(this.nextNudgeTimer);
    }

    if (!response?.nextEligibleAt) {
      return;
    }

    const delay = Math.max(response.nextEligibleAt - Date.now(), 0);
    this.nextNudgeTimer = setTimeout(async () => {
      if (!this.isUserActive()) {
        return;
      }
      await this.loadAndShowNudge();
    }, delay);
  }

  private isUserActive() {
    return (
      Date.now() - this.lastUserActivityAt <
      HomeComponent.NUDGE_ACTIVITY_WINDOW_MS
    );
  }
}
